import axios from 'axios';

// Criar axios SEM baseURL fixa - será construída dinamicamente
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para construir baseURL dinamicamente e adicionar token
api.interceptors.request.use(
  (config) => {
    // CONSTRUIR baseURL em RUNTIME
    if (!config.baseURL) {
      // Prioridade 1: Usar REACT_APP_BACKEND_URL se definido
      if (process.env.REACT_APP_BACKEND_URL) {
        config.baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;
      } else {
        // Prioridade 2: Construir dinamicamente usando window.location
        const protocol = window.location.protocol; // https:
        const host = window.location.host; // finance-module-3.preview.emergentagent.com
        config.baseURL = `${protocol}//${host}/api`;
      }
    }
    
    // Adicionar token se existir
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log para debug
    console.log('[API Request]', config.method?.toUpperCase(), config.baseURL + config.url);
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de resposta para tratamento de erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('[API Error]', error);
    return Promise.reject(error);
  }
);

export default api;